// assets
import { IconSettings, IconHistory, IconBell, IconHelp, IconContract } from '@tabler/icons-react';

// constant
const icons = { IconSettings, IconHistory, IconBell, IconHelp, IconContract };

// ==============================|| MANAGEMENT MENU ITEMS ||============================== //

const management = {
    id: 'management',
    title: '관리',
    type: 'group',
    children: [
        {
            id: 'user',
            title: '사용자 목록',
            type: 'item',
            url: '/management/user',
            icon: icons.IconSettings,
            breadcrumbs: true,
            children: [
                {
                    id: 'userRegister',
                    title: '사용자 등록',
                    type: 'item',
                    url: '/management/user/register',
                    icon: icons.IconContract,
                    breadcrumbs: true
                },
                {
                    id: 'userDetail',
                    title: '사용자 상세 정보',
                    type: 'item',
                    url: '/management/user/:id',
                    icon: icons.IconContract,
                    breadcrumbs: true,
                    children: [
                        {
                            id: 'userEdit',
                            title: '사용자 수정',
                            type: 'item',
                            url: '/management/user/:id/edit',
                            icon: icons.IconContract,
                            breadcrumbs: true
                        },
                        {
                            id: 'userPasswordChange',
                            title: '비밀번호 변경',
                            type: 'item',
                            url: '/management/user/:id/password/reset',
                            icon: icons.IconContract,
                            breadcrumbs: true
                        }
                    ]
                }
            ]
        },
        {
            id: 'license',
            title: '기기 및 라이선스',
            type: 'item',
            url: '/management/license',
            icon: icons.IconContract,
            breadcrumbs: true,
            children: [
                {
                    id: 'deviceRegister',
                    title: '기기 등록',
                    type: 'item',
                    url: '/management/license/device/register',
                    icon: icons.IconContract,
                    breadcrumbs: true
                },
                {
                    id: 'deviceDetail',
                    title: '기기 상세 정보',
                    type: 'item',
                    url: '/management/license/device/:id',
                    icon: icons.IconContract,
                    breadcrumbs: true,
                    children: [
                        {
                            id: 'deviceEdit',
                            title: '기기 수정',
                            type: 'item',
                            url: '/management/license/device/:id/edit',
                            icon: icons.IconContract,
                            breadcrumbs: true
                        }
                    ]
                }
            ]
        }
    ]
};

export default management;
